import {DropdownTag, ColorSchemeType} from 'platform/components';

import {Control, FieldPathByValue, useController} from 'react-hook-form';

import {TestDriveState, testDriveStateSchema} from '@dms/api/sales';
import i18n from '@dms/i18n';

import {TestDriveDialogSchemaType} from '../schemas/TestDriveDialogSchema';

interface TestDriveStateSwitcherProps {
  name: FieldPathByValue<TestDriveDialogSchemaType, string>;
  control: Control<TestDriveDialogSchemaType>;
  isDisabled?: boolean;
}

const TEST_DRIVE_STATE_LABEL_MAP: Record<TestDriveState, string> = {
  planned: i18n.t('entity.testDrive.labels.planned'),
  completed: i18n.t('entity.testDrive.labels.completed'),
  cancelled: i18n.t('entity.testDrive.labels.cancelled'),
} as const;

const TEST_DRIVE_STATE_COLOR_MAP: Record<TestDriveState, ColorSchemeType> = {
  planned: 'orange',
  completed: 'green',
  cancelled: 'red',
} as const;

export function TestDriveStateSwitcher(props: TestDriveStateSwitcherProps) {
  const {field} = useController({name: props.name, control: props.control});

  return (
    <DropdownTag
      isDisabled={props.isDisabled}
      size="large"
      colorScheme={TEST_DRIVE_STATE_COLOR_MAP[field.value as TestDriveState] ?? 'neutral'}
      label={i18n.t(TEST_DRIVE_STATE_LABEL_MAP[field.value as TestDriveState]) ?? 'Unknown'}
      dropdownItems={testDriveStateSchema.options
        .filter((option: TestDriveState) => option !== field.value)
        .map((option: TestDriveState) => ({
          label: i18n.t(TEST_DRIVE_STATE_LABEL_MAP[option]),
          onClick: () => field.onChange(option),
        }))}
    />
  );
}
